import { useParams, useSearchParams } from 'react-router-dom';
import { useEffect, } from 'react';
import axios from 'axios';
import { Typography } from '@mui/material';

const Makepayment = () => {
    const { orderId } = useParams();
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    const fetchOrderById = async () => {
        try {
            const response = await axios.get(`https://backend.tailors4u.com/Payment/getPaymentByOrderId?OrderId=${orderId}`,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }
            );
            const filterRecord = response?.data?.data.find((data) => data?.paymentMode === "Online" && data?.status === "Pending");
            window.location.href = filterRecord?.payment_link;
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        fetchOrderById();
    }, []);

    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
            <Typography>
                Redirect to payment link....
            </Typography>
        </div>

    )
}

export default Makepayment;